import styled from "styled-components";

export const Button = styled.button`
  width: 100%;
  display: flex;
  cursor: pointer;
  align-items: center;  
  transition: 0.25s all;
  justify-content: center;
  padding: 10px 25px 10px 25px;
  border-radius: var(--corner-radius);

  & > .icon {
    margin-top: 2px;
    margin-right: 4px;
  }
`;

export const ButtonSolid = styled(Button as any) <any>`
  background: ${(props: any) =>
    (() => {
      if (props.primary) {
        return "var(--color-primary)";
      } else if (props.secondary) {
        return "var(--color-secondary)";
      } else if (props.grey) {
        return "var(--color-default)";
      } else {
        return "var(--color-primary)";
      }
    })()};
  color: #fff;
  border: 1px solid transparent;

  &:hover {
    background: ${(props: any) =>
    (() => {
      if (props.primary) {
        return "var(--color-primary-dark)";
      } else if (props.secondary) {
        return "var(--color-secondary-dark)";
      } else if (props.grey) {
        return "var(--color-default-dark)";
      } else {
        return "var(--color-primary-dark)";
      }
    })()};
  }

  font-size: ${(props: any) =>
    (() => {
      if (props.small) {
        return "10px";
      } else if (props.medium) {
        return "12px";
      } else {
        return "14px";
      }
    })()};

  display: ${(props: any) =>
    (() => {
      if (props.auto) {
        return "inline-block";
      } else {
        return "flex";
      }
    })()};

  width: ${(props: any) =>
    (() => {
      if (props.auto) {
        return "auto";
      } else if (props.small) {
        return "125px";
      } else {
        return "100%";
      }
    })()};

  padding: ${(props: any) =>
    (() => {
      if (props.small) {
        return "3px 0px 3px 0px";
      } else {
        return "10px 25px 10px 25px";
      }
    })()};
`;

export const ButtonBorder = styled(Button)`
  background: transparent;
  color: var(--color-border);
  border: 1px solid var(--color-border);

  &:hover {
    background: transparent;
    color: var(--color-primary);
    border: 1px solid var(--color-primary);
  }
`;
